import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {PackageType} from "@/modules/mpackages/models/PackeageType";
import {ActivationType} from "@/modules/mpackages/models/ActivationType";

export class PackageBackendModel extends BaseObject {

    constructor() {
        super();
        this._id = '';
        this._type = ActivationType.DEACTIVATE_ON_RECIEVE
        this._packageType = PackageType.REWARD
        this._createdBy = ''
        this._name = ''
        this._description = ''
        this._activateOn = 0
        this._ttl = 0
        this._availableFor = []
        this._updated = 0
    }

    get id() {return this._id;}
    set id(value) {this._id = value;}

    get type() {return this._type;}
    set type(value) {this._type = value;}

    get packageType() {return this._packageType;}
    set packageType(value) {this._packageType = value;}

    get createdBy() {return this._createdBy;}
    set createdBy(value) {this._createdBy = value;}

    get name() {return this._name;}
    set name(value) {this._name = value;}

    get description() {return this._description;}
    set description(value) {this._description = value;}

    get activateOn() {return this._activateOn;}
    set activateOn(value) {this._activateOn = value;}

    get ttl() {return this._ttl;}
    set ttl(value) {this._ttl = value;}

    get availableFor() {return this._availableFor;}
    set availableFor(value) {this._availableFor = value;}

    get updated() {return this._updated;}
    set updated(value) {this._updated = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PackageBackendModel());
        } else if (target instanceof PackageBackendModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PackageBackendModel, {
    _id: alias("id", Schema.primitive()),
    _type: alias("type", ActivationType.schema()),
    _packageType: alias("packageType", PackageType.schema()),
    _createdBy: alias("createdBy", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _description: alias("description", Schema.primitive()),
    _activateOn: alias("activateOn", Schema.primitive()),
    _ttl: alias("ttl", Schema.primitive()),
    _availableFor: alias("availableFor", list(Schema.primitive())),
    _updated: alias("updated", Schema.primitive()),
});